import { useFormik } from '@fourthwall/utils/dist/formik'
import React from 'react'
import { getValidationSchema } from './utils'
import type { FormValues, PositionChangeModalProps } from './types'
import { FormFields } from './types'
import * as S from './styled'
import { ModalBox } from '../../partials/ModalBox'
import { Button } from '../../common/Button'
import { Fieldset } from '../../common/Fieldset/Fieldset'
import { RadioButton } from '../../inputs/RadioButton/RadioButton'
import { Input } from '../../inputs/Input'
import { InputUI } from '../../ui/Input'

export const PositionChangeModal = ({
  title,
  currentPosition,
  maxPosition,
  topPositionLabel = 'Move to top',
  bottomPositionLabel = 'Move to bottom',
  onSubmit,
  close,
}: PositionChangeModalProps) => {
  const formik = useFormik<FormValues>({
    initialValues: {
      type: undefined,
      exactPosition: currentPosition,
    },
    validationSchema: getValidationSchema(maxPosition, currentPosition),
    onSubmit: (values) => {
      onSubmit(values)
      close()
    },
  })

  return (
    <form onSubmit={formik.handleSubmit}>
      <ModalBox
        title={title}
        size="small"
        buttons={[
          <Button label="Cancel" appearance="secondary" onClick={close} />,
          <Button
            label="Update"
            appearance="primary"
            type="submit"
            disabled={!formik.isValid || !formik.dirty}
          />,
        ]}
        onClose={close}
      >
        <Fieldset>
          <Fieldset.Row>
            <RadioButton
              checkedValue="TOP"
              label={topPositionLabel}
              {...formik.getFieldProps(FormFields.type)}
            />
          </Fieldset.Row>
          <Fieldset.Row>
            <RadioButton
              checkedValue="BOTTOM"
              label={bottomPositionLabel}
              {...formik.getFieldProps(FormFields.type)}
            />
          </Fieldset.Row>
          <Fieldset.Row>
            <RadioButton
              checkedValue="EXACT"
              label="Set exact position"
              {...formik.getFieldProps(FormFields.type)}
            />
          </Fieldset.Row>
          {formik.values.type === 'EXACT' && (
            <>
              <Fieldset.Row inner>
                <S.ExactPositionContainer>
                  <S.InputContainer>
                    <Input
                      type="number"
                      hideSpinner
                      displayError={false}
                      {...formik.getFieldProps(FormFields.exactPosition)}
                    />
                  </S.InputContainer>
                  out of {maxPosition}
                </S.ExactPositionContainer>
              </Fieldset.Row>
              {formik.errors.exactPosition && (
                <S.InputErrorContainer>
                  <InputUI.Error>{formik.errors.exactPosition}</InputUI.Error>
                </S.InputErrorContainer>
              )}
            </>
          )}
        </Fieldset>
      </ModalBox>
    </form>
  )
}
